import { useWindowDimensions } from 'hooks/useWindowDimensions';
import { useEffect } from 'react';

export const useHiddenScrollBar = (isLoanVariablesDialogActive: boolean) => {
  const { isLargeWidth } = useWindowDimensions();

  useEffect(() => {
    if (!isLargeWidth && isLoanVariablesDialogActive) {
      document.body.classList.add('ignore-dialog-padding');
    } else {
      document.body.classList.remove('ignore-dialog-padding');
    }
  }, [isLoanVariablesDialogActive, isLargeWidth]);
};
